export function ImgVideoPlaceholder() {
  return (
    <svg className="model-preview model-preview-placeholder" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="60" height="60" rx="4" fill="currentColor" fillOpacity="0.08"/>
      <polygon points="44 30 21 17 21 43" fill="currentColor" fillOpacity="0.35"/>
    </svg>
  );
}
